// extracted by mini-css-extract-plugin
export default {"seriesMainDiv":"SeriesManagement_seriesMainDiv__KzzXU","addSeriesClick":"SeriesManagement_addSeriesClick__sJgEF","text":"SeriesManagement_text__hjEzJ"};